/**
 * Maestros y parámetros de DOLE (RF-C5).
 *
 * Escribe sobre la misma tabla `configuracion_det` que ya usa el sistema, pero
 * el backend acota todo a los grupos DOL-0000-*: desde aquí no se puede tocar
 * la configuración de otros módulos.
 */
const base = () => (process.env.REACT_APP_API_URL || '') + '/maestro-dole';

const auth = () => ({ 'Authorization': 'Bearer ' + (localStorage.getItem('jwt') || '').replaceAll('"', '') });
const authJson = () => ({ ...auth(), 'Content-Type': 'application/json' });

const manejar = async (resp) => {
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
        throw new Error(data.error || 'No se pudo completar la operación');
    }
    return data;
};

/** Pestañas disponibles. */
export const getGrupos = () => fetch(`${base()}/grupos`, { headers: auth() }).then(manejar);

/** Valores de un maestro (ej. todos los barcos). */
export const getValores = (grupoCodigo) =>
    fetch(`${base()}/grupo/${grupoCodigo}`, { headers: auth() }).then(manejar);

export const crear = (grupoCodigo, nombre, parametro) =>
    fetch(`${base()}/grupo/${grupoCodigo}`, {
        method: 'POST', headers: authJson(), body: JSON.stringify({ nombre, parametro })
    }).then(manejar);

export const actualizar = (configuracionDetId, nombre, parametro) =>
    fetch(`${base()}/${configuracionDetId}`, {
        method: 'PUT', headers: authJson(), body: JSON.stringify({ nombre, parametro })
    }).then(manejar);

/** Baja lógica: no borra, porque puede estar referenciado por bookings/ubicaciones. */
export const desactivar = (configuracionDetId) =>
    fetch(`${base()}/${configuracionDetId}`, { method: 'DELETE', headers: auth() }).then(manejar);

/** Cambia el valor de un parámetro DOLE (ej. patio_seco_distancia_m = 300). */
export const guardarParametro = (nombre, valor) =>
    fetch(`${base()}/parametro/${encodeURIComponent(nombre)}`, {
        method: 'PUT', headers: authJson(), body: JSON.stringify({ valor })
    }).then(manejar);

/** Carga masiva de un maestro (Nombre + Codigo; en Prioridad ademas Cut-Off). */
export const cargaMasiva = (grupoCodigo, file) => {
    const form = new FormData();
    form.append('file', file);
    return fetch(`${base()}/grupo/${grupoCodigo}/carga`, {
        method: 'POST', headers: auth(), body: form
    }).then(manejar);
};

/** Historial de cambios de un valor del maestro (RF-LOG). */
export const logMaestro = (configuracionDetId) =>
    fetch(`${base()}/${configuracionDetId}/log`, { headers: auth() }).then(manejar);

export const GRUPO_PARAMETROS = 'DOL-0000-0000';
export const GRUPO_BARCO = 'DOL-0000-0001';
export const GRUPO_PRIORIDAD_VACIO = 'DOL-0000-0004';
